import React, { useEffect } from 'react';
import RouteErrorPage from './RouteErrorPage';
import ProgramRecap from './ProgramRecap/ProgramRecap'
import ShipmentTracking from './ShipmentTracking/ShipmentTracking';
import ShipmentTrackingHome from './ShipmentTracking/ShipmentTrackingHome';
import OrderTrackingHome from './Shipments/OrderTrackingHome';
import Opportunity from './Shipments/Opportunity/Opportunity';
import QuestCodesManagement from './QuestCodesManagement/QuestCodesManagement';
import FeedbackWizardView from './FeedbackWizardView/FeedbackWizardView';
import FeedbackWizardTrainingView from './FeedbackWizardView/FeedbackWizardTrainingView';
import FeedbackWizardResultsView from './FeedbackWizardView/FeedbackWizardResultsView/FeedbackWizardResultsView';
import AssessmentManager from './AssessmentManager/AssessmentManager';
import AssessmentBuilder from './AssessmentManager/AssessmentBuilder/AssessmentBuilder';
import AssessmentReports from './AssessmentManager/AssessmentReports/AssessmentReports';
import AddEditAssessment from './AssessmentManager/AssessmentBuilder/AddEditAssessment/AddEditAssessment';
import QuestAssessmentDashboard from './QuestAssessmentDashboard/QuestAssessmentDashboard'
import PdLauncher from './PdExperience/PdLauncher';
import PdLeaderboard from './PdExperience/PdLeaderboard/PdLeaderboard';
import ImplementationCalendar from './ImplementationCalendar/ImplementationCalendar';
import AssetManager from './AssetManager/AssetManager';
// import useMediaQuery from './hooks/useMediaQuery';
import GlobalData, { GlobalDataContext } from './GlobalData'
import { appRootPath } from './utils';
import Router from './Router';
import '@prosolve/common-components-ui/dist/styles.css'
import { Outlet } from 'react-router-dom';

// Used to wrap route and override title seen in the browser Tab
const Page = (props) => {
  useEffect(() => {
    document.title = props.title || "";
  }, [props.title]);
  return props.children;
};

// Bare app root. CloudFront only routes /go/* here, so this is reached as /go/ (or on localhost);
// there is nothing to show at the root itself, so deployed users go back to the hub home.
const AppRoot = () => {
  const isDevMode = (window.location.host.indexOf('localhost') > -1)
  if (!isDevMode) {
    window.location.replace(window.location.origin);
    return <></>
  }
  return <RouteErrorPage />
}

export default () => {
  // const isMobileView = useMediaQuery('(max-width: 450px)');

  const globalData = new GlobalData();
  // globalData.setIsMobileView(isMobileView)

  const routes = [
    {
      path: appRootPath,
      element: () => <AppRoot />,
      errorElement: <RouteErrorPage />,
    },
    {
      path: `${appRootPath}/programRecap`,
      element: (routeProps) => (
        <Page title='ProSolve Program Recap'>
          <ProgramRecap {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/shipping`,
      isPrivate: true,
      accessKey: 'hasShippingAppAccess',
      element: (routeProps) => (
        <Page title='ProSolve Order Tracker'>
          <Outlet {...routeProps} />
        </Page>
      ),
      children: [
        {
          path: "",
          element: <OrderTrackingHome />
        },
        {
          path: ":tab",
          element: <OrderTrackingHome />
        },
      ]
    },
    {
      path: `${appRootPath}/ship`,
      element: (routeProps) => (
        <Page title='ProSolve Order Tracker'>
          <Outlet {...routeProps} />
        </Page>
      ),
      children: [
        {
          path: "opportunity/:opportunityId",
          element: <Opportunity />
        },
      ]
    },
    {
      path: `${appRootPath}/shipmentTracking`,
      isPrivate: true,
      accessKey: 'hasShippingAppAccess',
      element: (routeProps) => (
        <Page title='ProSolve Shipment Tracker'>
          <ShipmentTrackingHome {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/shipmentTracking/account`,
      isPrivate: true,
      accessKey: 'hasShippingAppAccess',
      element: (routeProps) => (
        <Page title='ProSolve Shipment Tracker'>
          <ShipmentTracking {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/studentSurvey`,
      element: (routeProps) => (
        <Page title='ProSolve Student Survey'>
          <FeedbackWizardView {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/survey`,
      element: (routeProps) => (
        <Page title='ProSolve Survey'>
          <FeedbackWizardView {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/trainingSurvey`,
      element: (routeProps) => (
        <Page title='ProSolve Survey'>
          <FeedbackWizardTrainingView {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/surveyResults`,
      element: (routeProps) => (
        <Page title='ProSolve Survey Results'>
          <FeedbackWizardResultsView {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/questCodes`,
      isPrivate: true,
      accessKey: 'hasQuestCodesAppAccess',
      element: (routeProps) => (
        <Page title='Quest Codes Management'>
          <QuestCodesManagement {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/assessmentManager`,
      isPrivate: true,
      accessKey: 'hasAssessmentAppAccess',
      element: (routeProps) => (
        <Page title='Assessment Manager'>
          <AssessmentManager {...routeProps} />
        </Page>
      ),
      children: [
        {
          path: "builder",
          element: <AssessmentBuilder />
        },
        {
          path: "builder/:assessmentName",
          element: <AddEditAssessment />
        },
        {
          path: 'reports',
          element: <AssessmentReports />
        }
      ]
    },
    {
      path: `${appRootPath}/questAssessmentDashboard`,
      isPrivate: true,
      isQuestDashboard: true,
      element: (routeProps) => (
        <Page title='Quest Assessment Dashboard'>
          <QuestAssessmentDashboard {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/pd`,
      element: (routeProps) => (
        <Page title='PD Launcher'>
          <PdLauncher {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/pdLeaderboard`,
      element: (routeProps) => (
        <Page title='PD Launcher'>
          <PdLeaderboard {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/implementationCalendar`,
      isPrivate: true,
      accessKey: 'hasImplementationCalendarAccess',
      element: (routeProps) => (
        <Page title='Implementation Calendar'>
          <ImplementationCalendar isPrivate={true} {...routeProps} />
        </Page>
      ),
    },
    {
      path: `${appRootPath}/assetManager`,
      isPrivate: true,
      accessKey: 'hasAssetManagerAccess',
      element: (routeProps) => (
        <Page title='Asset Manager'>
          <AssetManager isPrivate={true} {...routeProps} />
        </Page>
      ),
    },
    {
      // Anything outside the routes above (ranks below every /go/... path)
      path: '*',
      element: () => <RouteErrorPage />,
      errorElement: <RouteErrorPage />,
    },
  ]

  return (
    <GlobalDataContext.Provider value={globalData}>
      <Router routes={routes} />
    </GlobalDataContext.Provider>
  )
}